// Precomputed public artifacts published to Firebase Storage by the
// rebuildArtifacts Cloud Function. The manifest is the only mutable object;
// versioned files are content-addressed and immutable.
export const ARTIFACT_MANIFEST_PATH = 'artifacts/manifest.json'

export interface ArtifactManifestEntry {
  version: string
  path: string
  bytes: number
  builtAt: string
}

export interface ArtifactManifest {
  artifacts: Record<string, ArtifactManifestEntry>
}

export function artifactObjectPath(key: string, version: string): string {
  return `artifacts/${key}/${version}.json.gz`
}
